import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import type { ThunkDependencies } from "single-spa/store/thunk-dependencies";
import type { ThunkDispatchCommon, ThunkGetState } from "single-spa/store/types";
import { fetchCrmListsAsync } from "../actions/crmListsActions";
import { selectHasCrmLists } from "../selectors/crmListSelectors";

export const fetchCrmListsThunk = () => {
    return async (dispatch: ThunkDispatchCommon, getState: ThunkGetState, deps: ThunkDependencies) => {
        if (!salesSettingsHelper.isCrmIntegrationsEnabled()) {
            return;
        }

        dispatch(fetchCrmListsAsync.request());

        try {
            const lists = await deps.si.api.management.fetchCrmLists();

            dispatch(fetchCrmListsAsync.success(lists));
        } catch (error) {
            dispatch(fetchCrmListsAsync.failure(error));
        }
    };
};

export const fetchCrmListsIfMissingThunk = () => {
    return async (dispatch: ThunkDispatchCommon, getState: ThunkGetState) => {
        const hasCrmLists = selectHasCrmLists(getState());

        if (hasCrmLists) {return;}

        dispatch(fetchCrmListsThunk());
    };
};
